import { Injectable } from '@angular/core'
import { DialogService } from '@tokeet-frontend/tv3-platform'
import { SystemNotificationsOverlayComponent } from './system-notifications-overlay.component'

@Injectable()
export class SystemNotificationsOverlayService {
  constructor(private dialog: DialogService) {}

  public open() {
    return this.dialog.openDrawer(SystemNotificationsOverlayComponent, {
      panelClass: 'drawer-full-60',
    })
  }
}
